import Vue from 'vue'
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)

const DEFAULT_LANG = 'pl'

const locales = {
  zh: require('./i18n/zh.json'),
  en: require('./i18n/en.json'),
  pl: require('./i18n/pl.json'),
}
const i18n = new VueI18n({
  locale:DEFAULT_LANG,
  messages: locales,
})

export default i18n